import { render, staticRenderFns } from "./DispatchSummaryAssetTypes.vue?vue&type=template&id=a6bd448c&scoped=true"
import script from "./DispatchSummaryAssetTypes.vue?vue&type=script&lang=js"
export * from "./DispatchSummaryAssetTypes.vue?vue&type=script&lang=js"
import style0 from "./DispatchSummaryAssetTypes.vue?vue&type=style&index=0&id=a6bd448c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bd448c",
  null
  
)

export default component.exports